import { connect } from 'react-redux'
import ProductGroupSelectionPage from '../components/ProductGroupSelectionPage'
import { toggleBench, toggleDoor, togglePaneling, toggleLights, toggleStove } from '../actions/plan.js';

const mapStateToProps = (state, ownProps) => {
    return {
        hasBench: state.plan.hasBench,
        hasPaneling: state.plan.hasPaneling,
        hasStove: state.plan.hasStove,
        hasLights: state.plan.hasLights,
        hasDoor: state.plan.hasDoor
    };
}
const mapDispatchToProps = (dispatch, ownProps) => ({
    toggleBench: () => {
        dispatch(toggleBench());
    },
    toggleDoor: () => {
        dispatch(toggleDoor());
    },
    togglePaneling: () => {
        dispatch(togglePaneling());
    },
    toggleLights: () => {
        dispatch(toggleLights());
    },
    toggleStove: () => {
        dispatch(toggleStove());
    }

});

const ProductGroupSelectionPageContainer = connect(
    mapStateToProps, mapDispatchToProps
)(ProductGroupSelectionPage)

export default ProductGroupSelectionPageContainer